<div class="content-side h-100 d-flex flex-column sp-between bg-white">
  <div>
    <div class="mb-5">
      <img src="assets/images/logo-kaizen.webp" width="198" alt="">
    </div>
    <br>
    <div>
      <div *ngFor="let option of mainMenu" class="content-option mb-3 pointer animated"
        #rla="routerLinkActive" routerLinkActive="bg-blue-2 text-white" [routerLink]="[option.url]" (click)="goTo(option.url)">
        <img [src]="getIcon(option, rla.isActive)" alt="" class="me-2">
        <span class="fw-medium">{{option.name}}</span>
      </div>
    </div>
  </div>

  <!-- Sección inferior: Configuraciones y Cerrar sesión -->
  <div>
    <div *ngFor="let option of bottomMenu" class="content-option mb-3 pointer animated"
      #rla="routerLinkActive" routerLinkActive="bg-blue-2 text-white" [routerLink]="[option.url]" (click)="goTo(option.url)">
      <img [src]="getIcon(option, rla.isActive)" alt="" class="me-2">
      <span class="fw-medium">{{option.name}}</span>
    </div>
  </div>
</div>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>